import React, { useEffect, useState } from "react";
import apiClient from "../../../utils/apiclient";

const AdminApprovals = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await apiClient.get("/admin/approvals");
      setData(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleAction = async (id, value) => {
    try {
      await apiClient.put(`/admin/approvals/${id}`, {
        authorised: value,
      });

      setData((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, authorised: value } : item
        )
      );
    } catch (e) {
      console.error(e);
      alert("Failed to update");
    }
  };

  const displayValue = (value) =>
    value === null || value === undefined || value === "" ? "-" : value;

  return (
    <div className="w-full flex-1 flex flex-col min-h-0">
      <div className="flex justify-between items-center mb-2 flex-shrink-0 gap-3">
        <h2 className="text-base md:text-xl font-semibold text-gray-800 whitespace-nowrap">Admin Approvals</h2>
      </div>
      <div className="w-full flex-1 flex flex-col min-h-0">
        <div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className='min-w-max w-full bg-white shadow-md border-collapse'>
          <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
            <tr>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Public ID</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">ID</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Image</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Order ID</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Order Type</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Batch ID</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Date</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Customer ID</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Customer Name</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Customer Number</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left whitespace-nowrap">Rider name</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left whitespace-nowrap">Rider number</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Kitchen Name</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Order Date</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Delivery Slot</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Status</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Action</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, index) => (
              <tr key={index} className="border-b border-gray-300 hover:bg-gray-50 transition">
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.publicId)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.id)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                  <img
                    src={item.image}
                    alt="proof"
                    className="w-16 h-16 object-cover mx-auto rounded"
                  />
                </td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.orderId)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.orderType)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.batchId)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.localDate)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.customerId)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.customerName)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.customerNumber)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.riderName)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.riderNumber)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.kitchenName)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.orderDate)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{displayValue(item.deliverySlot)}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800 font-medium">
                  {item.authorised ? (
                    <span className="text-green-600">Approved</span>
                  ) : (
                    <span className="text-orange-500">Pending</span>
                  )}
                </td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                  <div className="flex items-center gap-2">
                    <button
                      className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded transition"
                      onClick={() => handleAction(item.id, true)}
                    >
                      Approve
                    </button>
                    <button
                      className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded transition"
                      onClick={() => handleAction(item.id, false)}
                    >
                      Reject
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </div>
    </div>
  );
};

export default AdminApprovals;